import { IMAGE_URL } from "../constants";

export const verifyAdvancedPlan = (customer) => {
  return customer?.haveWhiteLabelPlan;
}

export const verifyAdvancedPlanImage = (customer) => {
  const customerBackgroundImage = customer?.backgroundImage;
  const hasAdvancedPlan = verifyAdvancedPlan(customer);

  return (hasAdvancedPlan && customerBackgroundImage) ? `${IMAGE_URL}${customerBackgroundImage}` : '';
}